var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "0%",
  x2: "0%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  style: {
    stopColor: "#311c77",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  style: {
    stopColor: "#8c32be",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  style: {
    stopColor: "#ff2dff",
    stopOpacity: 1
  }
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M10.5 10a.5.5 0 0 0 .5-.5V9h.5a.5.5 0 0 0 0-1H11v-.5a.5.5 0 0 0-1 0V8h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 .5.5M14.786 9.429a.64.64 0 0 1-.61-.44l-.338-1.014a1.29 1.29 0 0 0-.813-.813l-1.014-.338a.643.643 0 0 1 0-1.22l1.014-.337c.383-.128.685-.43.813-.814l.338-1.014a.643.643 0 0 1 1.22 0l.337 1.014c.128.384.43.686.814.814l1.014.337a.643.643 0 0 1 0 1.22l-1.014.338c-.384.128-.686.43-.814.813l-.337 1.014a.64.64 0 0 1-.61.44m0-2.429c.201-.316.47-.584.786-.786a2.6 2.6 0 0 1-.786-.785c-.202.316-.47.584-.785.785.316.202.583.47.785.786"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M10.193 3.007c1.008 0 1.966.207 2.836.58l-.734.919a6.064 6.064 0 0 0-8.156 5.688 6.064 6.064 0 0 0 6.06 6.06 6.064 6.064 0 0 0 5.961-7.15l1.025-.616c.134.551.208 1.127.208 1.719 0 1.781-.65 3.41-1.722 4.669l5.153 5.153a.56.56 0 0 1 0 .802.56.56 0 0 1-.802 0l-5.153-5.153A7.17 7.17 0 0 1 10.2 17.4C6.22 17.4 3 14.18 3 10.2a7.2 7.2 0 0 1 6.83-7.19z"
})));
export default SvgAiSearch;